<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增功能开关' : '修改功能开关'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="650px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        size="mini"
      >
        <el-form-item label="渠道">
          <channel-selector
            placeholder="请选择"
            enableFullChannels
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="Key" prop="key">
          <el-input
            v-model="form.key"
            placeholder="约定好的一个代表目标功能的标识，比如“ios支付”"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="自定义参数">
          <el-input
            v-model="form.param"
            placeholder="和客户端约定好格式的参数，如需多个参数可用约定好的分隔符串起来"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="得通过第几关" prop="minLevel">
          <el-input
            v-model="form.minLevel"
            placeholder="填10就代表第10关"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="最低版本" prop="minVersion">
          <el-input
            v-model="form.minVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="最高版本" prop="maxVersion">
          <el-input
            v-model="form.maxVersion"
            placeholder="比如1.0.1"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.remark"
            placeholder="多少写点儿什么吧..."
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px">{{
          this.value.isCreate ? "确定" : "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        channelId: "",
        key: "",
        param: "",
        minLevel: "",
        minVersion: "",
        maxVersion: "",
        remark: "",
        status: "",
      },
      rules: {
        channelId: [{ required: true, message: " ", trigger: "blur" }],
        key: [{ required: true, message: " ", trigger: "blur" }],
        status: [{ required: true, message: " ", trigger: "blur" }],
        minLevel: [{ required: true, message: " ", trigger: "blur" }],
        minVersion: [{ required: true, message: " ", trigger: "blur" }],
        maxVersion: [{ required: true, message: " ", trigger: "blur" }],
      },
      statusOptions: [
        {
          value: 0,
          label: "关闭",
        },
        {
          value: 1,
          label: "开启",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  components: {
    ChannelSelector,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.channelId = this.value.oldData.channelId;
      this.form.key = this.value.oldData.key;
      this.form.param = this.value.oldData.param;
      this.form.minLevel = this.value.oldData.minLevel;
      this.form.minVersion = this.value.oldData.minVersion;
      this.form.maxVersion = this.value.oldData.maxVersion;
      this.form.remark = this.value.oldData.remark;
      this.form.status = this.value.oldData.status;
    } else {
      this.form.status = 0; // 给一个默认状态
    }
  },

  methods: {
    async onChannelSelectorReady() {
      if (!this.value.isCreate) {
        this.$refs.channelSelector.channelId = this.form.channelId;
      }
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    /**
     * 提交表单
     */
    submit() {
      if (this.form.channelId === "") {
        this.$alert("请选择渠道");
        return;
      }
      
      if (this.value.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    add() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addFunctionSwitch`,
            {
              switch: {
                channelId: this.form.channelId,
                key: this.form.key,
                param: this.form.param,
                minLevel: this.form.minLevel,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                remark: this.form.remark,
                status: this.form.status,
              },
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改
     */
    update() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateFunctionSwitch`,
            {
              switch: {
                channelId: this.form.channelId,
                id: this.value.oldData.id,
                key: this.form.key,
                param: this.form.param,
                minLevel: this.form.minLevel,
                minVersion: this.form.minVersion,
                maxVersion: this.form.maxVersion,
                remark: this.form.remark,
                status: this.form.status,
              },
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>